(function ($) {
  "use strict";
  $(document).ready(function () {
    accordion.initAccordion();
  });
})(jQuery);

export var accordion = (function () {
  var initAccordion = function () {
    const hashTarget = location.hash
      ? $(`${location.hash}, [name="${location.hash.slice(1)}"]`)
      : false;

    const accordionContainingHashTarget = $(hashTarget)
      .closest(".accordion")
      .first();

    // Collapse accordions since JS enabled
    $(".accordion")
      .not(".open")
      .each(function () {
        closeAccordion($(this));
      });

    // Open accordion containing the target of the URL hash
    $(accordionContainingHashTarget).each(function () {
      openAccordion($(this));
    });

    // Filter accordions should be open by default
    $(".accordion.form-filters").each(function () {
      openAccordion($(this));
    });

    $(".accordion-toggle").unbind("click");
    // bind toggle to heading anchor
    $(".accordion-toggle").on("click", function (e) {
      e.preventDefault();

      var accordion = $(this).closest(".accordion");

      if (accordion.hasClass("open")) {
        closeAccordion(accordion);
      } else {
        openAccordion(accordion);
      }
    });

    // Scroll to targeted accordion on page load
    if (window.location.hash) {
      var hashPath = window.location.hash.replace("#", "");
      const $hashTarget = $(`[name="${hashPath}"]`);
      // open the relevent accordion base on the hash ID
      if ($hashTarget.length) {
        var $parentAccordion = $hashTarget.closest(".accordion");
        if ($parentAccordion.length) {
          $("html, body").prop({ scrollTop: 0 });
          scrollToOpenedAccordion($parentAccordion);
        }
      }
    }
  };

  var closeAccordion = function (elem) {
    var accordionContent = elem.children(".accordion-content");
    var accordionBtn = elem.find("button.accordion-toggle");

    elem.removeClass("open");

    accordionContent.hide();

    accordionBtn.attr("aria-expanded", "false");
    accordionContent.attr("aria-expanded", "false");
  };

  var openAccordion = function (elem) {
    var accordionContent = elem.children(".accordion-content");
    var accordionBtn = elem.find("button.accordion-toggle");

    elem.addClass("open");

    accordionContent.show();

    accordionBtn.attr("aria-expanded", "true");
    accordionContent.attr("aria-expanded", "true");
  };

  var scrollToOpenedAccordion = function (elem) {
    $("html, body").animate(
      {
        // make sure the scroll include the sticky header height
        // if the sticky header was at it max height then assuming the header height will be 66 - fix height when scrolling start for header
        // else just get the current height header height
        scrollTop:
          elem.offset().top -
          ($("#sticky-header").outerHeight() === 145
            ? 66
            : $("#sticky-header").outerHeight()),
      },
      800,
      function () {
        elem.focus();

        // remove id attribute before location.hash to prevent page jump
        var tId = elem.attr("id");
        elem.attr("id", "");
        // add id attribute back
        elem.attr("id", tId);
      }
    );
  };

  return {
    initAccordion: initAccordion,
    closeAccordion: closeAccordion,
    openAccordion: openAccordion,
  };
})();
